import { render } from "./_filter.vue?vue&type=template&id=230bd0dc&lang=pug"
import script from "./_filter.vue?vue&type=script&lang=js"
export * from "./_filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__